module.exports = __webpack_public_path__ + "assets/img/star1.1170785d.webp";